module.exports = __webpack_public_path__ + "static/media/core-abstract-large.efbd7867.jpg";